import React, { useCallback, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Box, Card, CardContent } from "@mui/material";
import { getJobExecutionsForVehiclesFilter } from "../../services/vehicle";
import { getDeploymentVehicleLogDetailsFilter } from "../../services/deployment";
import { getColumnsData } from "./VehicleDeploymentColumns";
import OTAPagination from "../OTAPagination";

const VehicleDeploymentList = (props = {}) => {

  let { vehicleId, deploymentId } = useParams();
  const {
    vehicles = [],
    type,
    setErrMsg = () => { },
    setShowJobDocument,
    jobStatusFilter,
  } = props;
  const [vehicle] = vehicles;

  const getVehicleExecutionsFn = useCallback(
    ({ queryKey }) => {
      return getJobExecutionsForVehiclesFilter({
        queryKey: [...queryKey, deploymentId, vehicle?.vehicleKey],
      });
    },
    [deploymentId, vehicle?.vehicleKey]
  );

  const getDeploymentLogFn = useCallback(
    ({ queryKey }) => {
      return getDeploymentVehicleLogDetailsFilter({
        queryKey: [...queryKey, deploymentId],
      });
    },
    [deploymentId]
  );

  const columns = useMemo(
    () => getColumnsData({ vehicleId, deploymentId, type }),
    [vehicleId, deploymentId, type]
  );
  const endpointFn = type === "vehicle" ? getVehicleExecutionsFn : getDeploymentLogFn;
  const queryName = type === "vehicle" ? "jobExecutionsForVehicle" : "deploymentVehicleLogs";

  const filters = useMemo(() => {
    if (!jobStatusFilter) {
      return [];
    }
    return [
      {
        field: "jobExecutionStatus",
        columnField: "jobExecutionStatus",
        operator: "equals",
        operatorValue: "equals",
        value: jobStatusFilter,
        label: "Job Status",
        displayValue: jobStatusFilter,
      },
    ];
  }, [jobStatusFilter]);

  return (
    <Grid item size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
      <Box
        sx={{
          "& .MuiDataGrid-root": {
            minHeight: "unset !important",
          },
          "& .MuiDataGrid-main": {
            minHeight: "170px",
          },
          "& .MuiDataGrid-virtualScroller": {
            minHeight: "auto",
            paddingBottom: "40px !important",
          },
          width: "100%",
        }}
      >
        <Card variant="outlined">
            <CardContent
               sx={{ p: 0 , "&:last-child":{pb:0}}}
            >
              <OTAPagination
                tableTitle={type === "vehicle" ? "" : "Vehicles in Deployment"}
                columns={columns}
                endpointFn={endpointFn}
                queryName={queryName}
                filterMode="server"
                sortByDefault={"createdAt"}
                getRowId={(row) => row.deploymentLogId ?? row.executionId}
                exportCSV={type !== "vehicle"}
                onSuccess={() => setShowJobDocument?.(true)}
                filters={filters}
                extraQueriesToInvalidate={["jobStatus"]}
                autoHeight={true}
              />
            </CardContent>
          </Card>
      </Box>
    </Grid>
  );
};

export default VehicleDeploymentList;